import React, { useState } from "react";
import { useSelector } from "react-redux";
import { IStore } from "@/redux/defaultStore";
import { InviteModal } from "@/components/InviteModal";
import styles from "./ActionCards.module.scss";

interface InviteShareCardProps {
    onShare?: () => void;
    onModalOpen?: () => void;
    onModalClose?: () => void;
}

const InviteShareCard: React.FC<InviteShareCardProps> = ({ onShare, onModalOpen, onModalClose }) => {
    const [showInviteModal, setShowInviteModal] = useState(false);
    const currentUser = useSelector((store: IStore) => store.metaStore.currentUser);

    // Generate referral code for display
    const referralCode = currentUser?.user?.referralCode || currentUser?.user?.id?.slice(-6) || "DEVOUR";

    const handleOpenInvite = () => {
        setShowInviteModal(true);
        if (onModalOpen) onModalOpen();
    };

    const handleCloseInvite = () => {
        setShowInviteModal(false);
        // Only call onModalClose, don't call onShare unless actually sharing
        if (onModalClose) onModalClose();
    };

    return (
        <>
            <div
                className="stat-card"
                onClick={handleOpenInvite}
                style={{
                    cursor: "pointer",
                    backgroundImage: "url(/images/card-bck8.png)",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    border: "1px solid rgba(66, 133, 244, 0.3)",
                    boxShadow: "inset 0 1px 0 rgba(255, 255, 255, 0.1), 0 4px 12px rgba(0, 0, 0, 0.4)",
                    position: "relative",
                }}
            >
                <div style={{
                    position: "absolute",
                    top: 0, left: 0, right: 0, bottom: 0,
                    background: "rgba(0, 0, 0, 0.4)",
                    borderRadius: "inherit",
                }}></div>
                <div style={{ position: "relative", zIndex: 1 }}>
                    <h4 style={{ color: "white", textShadow: "0 2px 4px rgba(0, 0, 0, 0.9)", fontWeight: "700", letterSpacing: "0.5px" }}>👥 INVITE FRIENDS</h4>
                    <div className="stat-value" style={{ color: "#4285f4", textShadow: "0 2px 4px rgba(0, 0, 0, 0.9)", fontWeight: "700", fontSize: "1.1rem" }}>REFER NOW</div>
                    <div className="stat-subtitle" style={{ color: "rgba(255, 255, 255, 0.95)", textShadow: "0 1px 2px rgba(0, 0, 0, 0.9)", fontWeight: "500" }}>Earn rewards together</div>
                </div>
            </div>

            {/* Invite Modal */}
            <InviteModal
                isVisible={showInviteModal}
                onClose={handleCloseInvite}
            />
        </>
    );
};

export default InviteShareCard;